import {AfterViewInit, Component, ElementRef, HostBinding, Input, OnDestroy, OnInit} from '@angular/core';
import {GeoJSON, Map, tileLayer} from 'leaflet';
import {ReplaySubject, Subscription} from 'rxjs';
import {FlowMeterData, FlowMeterDataLoader, FlowMeterEntry} from 'shared';
import * as L from 'leaflet';
import {delay, first} from 'rxjs/operators';
import {minBy, maxBy} from 'lodash';
import 'leaflet.heat';
import moment from 'moment';
import {Feature} from 'geojson';

@Component({
  selector: 'app-flow-meter-heatmap',
  templateUrl: './flow-meter-heatmap.component.html',
  styleUrls: ['./flow-meter-heatmap.component.scss']
})
export class FlowMeterHeatmapComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input()
  loader: FlowMeterDataLoader;
  private loaderSub: Subscription;
  flowMeterData: FlowMeterData;

  isLoading = true;

  private map: Map;
  mapReady$ = new ReplaySubject<Map>(1);

  mapCss: any;
  @Input()
  width: number;

  @Input()
  height: number;
  private heatmap: any;
  private routePathFeature: any;
  private path: GeoJSON<Feature>;

  @HostBinding('style.width')
  get hostWidth() {
    return this.width + 'px';
  }

  @HostBinding('style.height')
  get hostHeight() {
    return this.height + 'px';
  }

  private maxHRTotalConsumption: FlowMeterEntry;
  private minHRTotalConsumption: FlowMeterEntry;


  layers = [
    {
      name: 'Hybride',
      layer: tileLayer('https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}&hl=ar-MA&gl=MA', {
        maxZoom: 21,
        subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
      }),
    },
    {
      name: 'Satellite',
      layer: tileLayer('https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}&hl=ar-MA&gl=MA', {
        maxZoom: 21,
        subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
      }),
    },
  ];

  options = {
    layers: this.layers.map(l => l.layer),
    zoom: 7,
    minZoom: 0,
    maxZoom: 21,
    maxNativeZoom: 21,
    preferCanvas: false,
    center: [33.626756199999996, -7.4964748]
  };

  constructor(
    public host: ElementRef,
  ) {
  }

  ngOnInit(): void {
    this.mapCss = {
      width: this.width + 'px',
      height: this.height + 'px',
    };

    this.loaderSub = this.loader.loading$.subscribe(isLoading => {
      if (this.loader.isEmpty()) {
        return;
      }
      if (isLoading) {
        this.clean();
        return;
      }

      this.mapReady$.pipe(first(), delay(30)).subscribe(() => {
        this.draw();
      });

    });
  }

  ngAfterViewInit(): void {
    this.mapReady$.pipe(first(), delay(30)).subscribe(() => {
      this.map.invalidateSize({
        animate: true,
      });
    });
  }

  onMapReady(map: Map) {
    this.map = map;
    this.mapReady$.next(map);
    L.control.scale({imperial: false}).addTo(map);
    // this.addFields();
    this.isLoading = false;
  }

  private clean() {
    this.map.removeLayer(this.heatmap);
    this.map.removeLayer(this.path);
  }

  ngOnDestroy(): void {
    this.loaderSub.unsubscribe();
  }

  private draw() {
    this.drawPath();

    this.minHRTotalConsumption = minBy<FlowMeterEntry>(this.loader.data.data, o => o.fuel_hr_total_consumption_diff);
    this.maxHRTotalConsumption = maxBy<FlowMeterEntry>(this.loader.data.data, o => o.fuel_hr_total_consumption_diff);
    const diff = this.maxHRTotalConsumption.fuel_hr_total_consumption_diff - this.minHRTotalConsumption.fuel_hr_total_consumption_diff;

    const data = this.loader.data.data.map(e => {
      return [e.lat, e.lng, (e.fuel_hr_total_consumption_diff - this.minHRTotalConsumption.fuel_hr_total_consumption_diff) / diff];
    });
    this.heatmap = L.heatLayer(data as any, {radius: 25, blur: 15});
    this.heatmap.addTo(this.map);

  }

  private drawPath() {
    // Build the route feature
    this.routePathFeature = {
      type: 'Feature',
      geometry: {
        type: 'LineString',
        coordinates: this.loader.data.data.map(r => [r.lng, r.lat])
      },
    };

    this.path = new GeoJSON<Feature>(this.routePathFeature);
    this.path.setStyle({
      color: '#5081f8',
      weight: 3,
      opacity: 0.7
    });

    this.path.addTo(this.map);
    this.path.bringToBack();

    this.map.fitBounds(this.path.getBounds(), {
      padding: [20, 20],
      animate: true,
    });
  }
}
